import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

interface TruncatedCreditsProps {
  credits: string[];
  mentorId: string;
  maxLines?: number;
}

const TruncatedCredits = ({ credits, mentorId, maxLines = 4 }: TruncatedCreditsProps) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  const creditsText = credits.join(', ');

  useEffect(() => {
    const checkTruncation = () => {
      if (textRef.current) {
        const lineHeight = parseInt(window.getComputedStyle(textRef.current).lineHeight);
        const maxHeight = lineHeight * maxLines;
        setIsTruncated(textRef.current.scrollHeight > maxHeight);
      }
    };

    checkTruncation();
    window.addEventListener('resize', checkTruncation);
    return () => window.removeEventListener('resize', checkTruncation);
  }, [creditsText, maxLines]);

  return (
    <div>
      <div 
        ref={textRef}
        className="text-xs text-muted-foreground leading-relaxed"
        style={{ 
          display: '-webkit-box', 
          WebkitLineClamp: maxLines, 
          WebkitBoxOrient: 'vertical', 
          overflow: 'hidden' 
        }}
      >
        {creditsText}
      </div>
      <div className="mt-1 h-5">
        {isTruncated ? (
          <Link 
            to={`/mentor/${mentorId}`}
            className="text-xs text-primary hover:text-primary/80 transition-colors inline-block"
          >
            See more...
          </Link>
        ) : (
          <span className="text-xs inline-block" aria-hidden="true"></span>
        )}
      </div>
    </div>
  );
};

export default TruncatedCredits;